import React from 'react';
import './Section2.css';

function Section2() {
  return (
    <div>Section2</div>
  )
}

export default Section2